<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :before-close="close"
      @open="openSearch"
      :title="$lang('综合修改')"
    >
      <div class="dialog-content">
        <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=":" label-width="80px">
          <div>
            <h3>{{ $lang('收件人信息') }}</h3>
            <div class="group-content">
              <el-form-item :label="$lang('联系电话')" prop="currentReceiverMobilePhone">
                <BasePhoneInput :value="phoneVal2" v-model="formData.currentReceiverMobilePhone"></BasePhoneInput>
              </el-form-item>
              <el-form-item :label="$lang('收件人备用手机号码')" prop="currentReceiverTelphone">
                <BasePhoneInput :value="phoneVal3" v-model="formData.currentReceiverTelphone"></BasePhoneInput>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button class="h40" @click="close">{{ $lang('取 消') }}</el-button>
        <el-button type="primary" :loading="keyBtn" @click="editSave" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { updateReceiverMobilePhone } from '@api/module/customer'
import { RULES, phoneAndMobile } from '@utils/rules'

export default {
  name: 'ComprehensiveEdit',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: _ => { },
    },
    waybillLogStatus: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      viewDialogVisible: false,
      codCurrencyType: [],
      formData: {
        currentReceiverMobilePhone: '',
        currentReceiverTelphone: '',
        previousReceiverMobilePhone: '',
        previousReceiverTelphone: '',
        codCurrencyTypeName: '',
        codMoney: '',
        codFee: '',
      },
      rules: {
        currentReceiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        currentReceiverTelphone: [RULES.lengthEleven, { validator: phoneAndMobile }],
      },
      phoneVal2: '',
      phoneVal3: '',
      receiverTelphone: '',
      keyBtn: false,
    }
  },
  created () {
    // this.getCurrencyTypeList()
  },
  methods: {
    openSearch() {
      const { waybillNo, receiverMobilePhone, receiverTelphone } = this.rowData
      this.formData.currentReceiverMobilePhone = receiverMobilePhone
      this.formData.currentReceiverTelphone = receiverTelphone
      this.formData.previousReceiverMobilePhone = receiverMobilePhone
      this.formData.previousReceiverTelphone = receiverTelphone
      this.formData = {
        ...this.formData,
        receiverMobilePhone,
        receiverTelphone,
        waybillNo,
      }
    },
    close() {
      this.$emit('update:visible', false)
    },
    async editSave () {
      console.log(this.rowData)
      this.$refs.sizeForm.validate(async valid => {
        if (valid) {
          this.keyBtn = true
          try {
            const { data, succ, msg } = await updateReceiverMobilePhone(this.formData)
            if (succ) {
              this.$message.success(this.$t('修改成功'))
              this.$emit('submit', data)
              this.keyBtn = false
              this.close()
            } else {
              this.keyBtn = false
              this.$message.error(msg)
            }
          } catch (error) {
            this.keyBtn = false
            console.log('resetPassword::', error)
          }
        }
      })
    },
  },
}
</script>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 650px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 0px;
  border-radius: 8px;
}
</style>
